import { render, staticRenderFns } from "./CreateTRDA.vue?vue&type=template&id=7af8b05d&scoped=true&"
import script from "./CreateTRDA.vue?vue&type=script&lang=ts&"
export * from "./CreateTRDA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af8b05d",
  null
  
)

export default component.exports